function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.39 2.17v6.45H1.93v-.68c0-3.61 2.15-5.76 5.76-5.76h.7v-.01zm13.38 5.76c0 .38-.31.68-.68.68h-5.75V2.16h.67c3.18.01 5.76 2.59 5.76 5.77zM8.39 15.55v5.76c0 .38-.31.68-.68.68H7.7c-3.18 0-5.76-2.58-5.76-5.76v-.68h6.45z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M8.4 8.61H1.94v6.94H8.4V8.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.33 8.61v6.26c0 .38-.31.68-.68.68H8.39V8.61h6.94z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15.33 2.17H8.39v6.45h6.94V2.17zM19.8 20.7l-1.9 1.91c-.52.52-1.38.52-1.92 0l-1.58-1.59c-.52-.53-.52-1.38 0-1.92l1.91-1.89 3.49 3.49z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.61 17.9l-2.81 2.8-3.49-3.49 2.8-2.82c.53-.52 1.39-.52 1.92 0l1.58 1.59c.52.53.52 1.4 0 1.92z"
})));